/*** IMPORTS FROM imports-loader ***/
var global = window;

var adjacent = require('./helper/adjacent');

module.exports = function succ(str) {
  return adjacent(str, -1);
};

